import React, { ReactElement } from "react";
import { Navigate, useNavigate, useLocation, useParams } from "react-router-dom";
import { useCoastguard } from "@cofano/coastguard2-frontend-client";
import queryString from "query-string";
import { useStoreState } from "ezStore";
import "../../styling/main.scss";
import { hasPluginPermission } from "components/utils/Permission";
import TermsOfService from "components/routes/TermsOfService";

export default function PrivateRoute({ children }: { children: ReactElement }) {

	const { instance: { isAuthenticated } } = useCoastguard();
	const session = useStoreState(store => store.session);
	const navigate = useNavigate();
	const location = useLocation();
	const params = useParams();
	const loc = useLocation();
	const usesTermsOfService = hasPluginPermission(session, "termsOfService");

	const navigateProps: BOSRoute = {
		history: {
			push: navigate,
			location: {
				pathname: loc.pathname,
			},
		},
		location: {
			pathname: loc.pathname,
			state: loc.state,
		},
		params: queryString.parse(loc.search),
		pathId: params.id,
	};

	if (!isAuthenticated) {
		return (
			<Navigate
				to="/view/login"
				state={{
					redirectLocation: location.pathname || null,
				}} />
		);
	}

	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	if (!session.user?.properties) {
		return <React.Fragment />;
	}

	if (usesTermsOfService && !session.user.properties.validated) {
		return <TermsOfService />;
	}

	return React.cloneElement(children, { ...navigateProps }, null);
}

export type BOSRoute = {
	history: {
		push: (url: string) => void,
		location: {
			pathname: string
		}
	},
	location: {
		pathname: string
		state: unknown,
	},
	params?: Record<string, string | (string | null)[] | null>
	pathId?: string
}


